import React, { Component, ErrorInfo, ReactNode } from "react";
import { View } from "react-native";
import RNRestart from "react-native-restart";

import AlertModal from "@/components/molecules/AlertModal";
import { logger } from "@/services/logger";
import { isNativeDevice } from "@/utils/platform";

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.error(error, errorInfo);
  }

  restartApp = () => {
    if (isNativeDevice) {
      RNRestart.restart();
    } else {
      window?.location?.reload();
    }
  };

  public render() {
    if (this.state.hasError) {
      return (
        <View>
          <AlertModal
            isOpen={true}
            title="Ooops!"
            message="Ocorreu um erro inesperado no iFeira, reinicie o app para continuar."
            primaryButtonText="Reiniciar"
            onClose={() => {
              this.restartApp();
            }}
            onPressPrimaryButton={() => {
              this.restartApp();
            }}
          />
        </View>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
